import { Box } from '@mui/material';
import { styled } from '@mui/system';

export const RoleBox = styled(Box)({
  padding: '5px 30px',
  backgroundColor: '#DAFFF3',
  fontSize: '12px',
  lineHeight: '14.06px',
  marginRight: '8px',
  cursor: 'pointer',
  color: '#111111',
  fontWeight: 500,
});
